/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getQuickReorder = /* GraphQL */ `
  query GetQuickReorder($id: ID!) {
    getQuickReorder(id: $id) {
      id
      user_id
      product_id
      stock
      variant
      last_order
      brand_id
      category_id
      created_at
      updated_at
      seller_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQuickReorders = /* GraphQL */ `
  query ListQuickReorders(
    $filter: ModelQuickReorderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuickReorders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        product_id
        stock
        variant
        last_order
        brand_id
        category_id
        created_at
        updated_at
        seller_id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrders = /* GraphQL */ `
  query GetOrders($id: ID!) {
    getOrders(id: $id) {
      id
      user_id
      product_id
      seller_id
      quantity
      status
      variant
      shipping_address
      created_at
      updated_at
      brand_id
      category_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        product_id
        seller_id
        quantity
        status
        variant
        shipping_address
        created_at
        updated_at
        brand_id
        category_id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSellerInfo = /* GraphQL */ `
  query GetSellerInfo($id: ID!) {
    getSellerInfo(id: $id) {
      id
      user_id
      business_name
      description
      phone
      street
      suite
      city
      state
      country
      postal_code
      tax_id
      tax_documents
      is_verified
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSellerInfos = /* GraphQL */ `
  query ListSellerInfos(
    $filter: ModelSellerInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSellerInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        business_name
        description
        phone
        street
        suite
        city
        state
        country
        postal_code
        tax_id
        tax_documents
        is_verified
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVariantAttribute = /* GraphQL */ `
  query GetVariantAttribute($id: ID!) {
    getVariantAttribute(id: $id) {
      id
      name
      created_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVariantAttributes = /* GraphQL */ `
  query ListVariantAttributes(
    $filter: ModelVariantAttributeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVariantAttributes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        created_by
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCategories = /* GraphQL */ `
  query GetCategories($id: ID!) {
    getCategories(id: $id) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        image
        is_active
        is_deleted
        updated_by
        deleted_by
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBrands = /* GraphQL */ `
  query GetBrands($id: ID!) {
    getBrands(id: $id) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBrands = /* GraphQL */ `
  query ListBrands(
    $filter: ModelBrandsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        image
        is_active
        is_deleted
        updated_by
        deleted_by
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductInfo = /* GraphQL */ `
  query GetProductInfo($id: ID!) {
    getProductInfo(id: $id) {
      id
      brand_id
      category_id
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      seller_id
      variants
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductInfos = /* GraphQL */ `
  query ListProductInfos(
    $filter: ModelProductInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        brand_id
        category_id
        is_active
        is_deleted
        updated_by
        deleted_by
        created_at
        updated_at
        seller_id
        variants
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($id: ID!) {
    getUserInfo(id: $id) {
      id
      user_id
      first_name
      last_name
      email
      has_roles
      current_role
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        first_name
        last_name
        email
        has_roles
        current_role
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStylistInfo = /* GraphQL */ `
  query GetStylistInfo($id: ID!) {
    getStylistInfo(id: $id) {
      id
      user_id
      saloon_name
      phone
      street
      suite
      city
      state
      country
      postal_code
      is_verified
      license_path
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStylistInfos = /* GraphQL */ `
  query ListStylistInfos(
    $filter: ModelStylistInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStylistInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        saloon_name
        phone
        street
        suite
        city
        state
        country
        postal_code
        is_verified
        license_path
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserShippingAddress = /* GraphQL */ `
  query GetUserShippingAddress($id: ID!) {
    getUserShippingAddress(id: $id) {
      id
      user_id
      shipping_address
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserShippingAddresses = /* GraphQL */ `
  query ListUserShippingAddresses(
    $filter: ModelUserShippingAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserShippingAddresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user_id
        shipping_address
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserBilling = /* GraphQL */ `
  query GetUserBilling($id: ID!) {
    getUserBilling(id: $id) {
      id
      user_id
      customer_id
      payment_id
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserBillings = /* GraphQL */ `
  query ListUserBillings(
    $filter: ModelUserBillingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserBillings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        customer_id
        payment_id
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCartItems = /* GraphQL */ `
  query GetCartItems($id: ID!) {
    getCartItems(id: $id) {
      id
      user_id
      product_id
      quantity
      variant
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCartItems = /* GraphQL */ `
  query ListCartItems(
    $filter: ModelCartItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCartItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        product_id
        quantity
        variant
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSellerPaymentInfo = /* GraphQL */ `
  query GetSellerPaymentInfo($id: ID!) {
    getSellerPaymentInfo(id: $id) {
      id
      seller_id
      account_holder_name
      bank_name
      routing_number
      account_number
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSellerPaymentInfos = /* GraphQL */ `
  query ListSellerPaymentInfos(
    $filter: ModelSellerPaymentInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSellerPaymentInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seller_id
        account_holder_name
        bank_name
        routing_number
        account_number
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
